class SiteMsgSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }


  init() {
    console.log(swiperManager)
    const sliderEl = this.querySelector('.swiper-container-top-bar');
    if (!sliderEl) return;

    const currentBrand = this.dataset.brand || '';
    const key = `site_msg_hidden_until_${currentBrand}`;

    const hiddenUntil = localStorage.getItem(key);
    if (hiddenUntil && new Date() < new Date(hiddenUntil)) {
      this.style.display = 'none';
      return;
    }

    this.initSwiper(sliderEl);

    this.querySelectorAll('.site-msg-close').forEach((btn) => {
      btn.addEventListener('click', () => {
        this.hideForDuration(key, 30); 
      });
    });
  }


  initSwiper(sliderEl) {
    try {
      if (typeof swiperManager !== 'undefined') {
        console.log(swiperManager)
        new swiperManager('.swiper-container-top-bar', {
          onlyMobile: false,
          swiper: {
            slidesPerView: 1,
            loop: true,
            speed: 800,
            autoplay: {
              delay: 3000,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            pagination: false,
          },
        });
      } else if (window.Swiper) {
        new Swiper(sliderEl.querySelector('.swiper'), {
          slidesPerView: 1,
          loop: true,
          speed: 800,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      }
    } catch (err) {
      console.error('[SiteMsgSlider] Swiper init failed:', err);
    }
  }

  hideForDuration(key, minutes) {
    this.style.display = 'none';
    const hideUntil = new Date(Date.now() + minutes * 60 * 1000);
    localStorage.setItem(key, hideUntil.toISOString());
  }
}

customElements.define('site-msg-slider', SiteMsgSlider);
